/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportPageImportJobView } from '../../models/api-response-import-page-import-job-view';

export interface ImportHistory$Params {
  'x-api-requestId'?: string;
  page?: number;
  size?: number;
}

export function importHistory(http: HttpClient, rootUrl: string, params?: ImportHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportPageImportJobView>> {
  const rb = new RequestBuilder(rootUrl, importHistory.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportPageImportJobView>;
    })
  );
}

importHistory.PATH = '/v1/api/ui/imports';
